import {createStyles, makeStyles, Theme, Tooltip} from "@material-ui/core";
import React from "react";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    hidden: {
      opacity: 0
    }
  }),
);

export const CursorTooltip = (props) => {
  const classes = useStyles();

  const {text} = props;
  const [position, setPosition] = React.useState({
    x: undefined,
    y: undefined
  });

  const createMarkup = () => {
    return text ?
      (<div dangerouslySetInnerHTML={{__html: text}}/>) :
      "";
  };

  const hidden = text === "";

  return (
    <Tooltip
      arrow
      title={createMarkup()}
      placement="right"
      classes={{
        popper: hidden ? classes.hidden : ""
      }}
      onMouseMove={event => setPosition({
        x: event.pageX,
        y: event.pageY
      })}
      PopperProps={{
        anchorEl: {
          clientHeight: 0,
          clientWidth: 0,
          getBoundingClientRect: () => ({
            top: position.y,
            left: position.x,
            right: position.x,
            bottom: position.y,
            width: 0,
            height: 0,
          })
        }
      }}
    >
      {props.children}
    </Tooltip>
  );
};